import React, { Component } from 'react';
import {Howl, Howler} from 'howler';

import './transitions.css';
import './InteractionPendules.css';


import { isInside, getGesturePointFromEvent } from './Tools.js'

const _ANGLE_LIMIT_DEP = 60; // angle max entre deux step (touchmove) ou on ne considère pas l'évent (cas d'erreurs de valeurs)
const _SPEED_ROTATE = 1.0;  // multiplicateur de vitesse pour la rotation des aiguilles
const _HEURE0 = 2;
const _MINUTE0 = 40;
const _SEUIL_DETECTION_MINUTE = 5;

class InteractionPendules extends Component {

    constructor(props) {

        super(props);       

        this.handlerDom = null;
        this.setHandlerDom = element => {
            this.handlerDom = element;
        };    
        this.setHandlerPendule1 = element => {
            this.handlerPendule1 = element;
        };    
        this.setHandlerPendule2 = element => {
            this.handlerPendule2 = element;
        };    

        this.handleGestureStart = this.handleGestureStartFn.bind(this);
        this.handleGestureEnd = this.handleGestureEndFn.bind(this);
        this.handleGestureMove = this.handleGestureMoveFn.bind(this);             
        
        this.touchStart = false;

        this._last_angle = false;
        this.loop_sound = false;
        this.engrenage_sound = false;

        this.state =
        {
            heure1 : parseInt(Math.random()*11,10),
            minute1 : parseInt(Math.random()*59,10),
            heure2 : parseInt(Math.random()*11,10),
            minute2 : parseInt(Math.random()*59,10),
            animation1 : false,
            animation2 : false,
        };
        
    }

    componentDidMount() 
    {
        //initRequestAnimFrame();       

        
        // Add Touch Listener
        this.handlerDom.addEventListener('touchstart', this.handleGestureStart, true);
        this.handlerDom.addEventListener('touchmove', this.handleGestureMove, true);
        this.handlerDom.addEventListener('touchend', this.handleGestureEnd, true);
        this.handlerDom.addEventListener('touchcancel', this.handleGestureEnd, true);

        // Add Mouse Listener
        this.handlerDom.addEventListener('mousedown', this.handleGestureStart, true);
        
        this.touchStart = false;        

        this.isAiguille1Finished = false;
        this.isAiguille2Finished = false;

        /* loop sound */

        this.loop_sound = new Howl({
            src: './Interactifs/CH15/background.mp3',
            autoplay: true,
            loop: true
          });         
          
        this.engrenage_sound = new Howl({
            src: './Interactifs/CH15/engrenage.mp3',
            loop: true
        });              
        
    }    


    componentWillUnmount()
    {
        // Remove Touch Listener
        this.handlerDom.removeEventListener('touchstart', this.handleGestureStart);
        this.handlerDom.removeEventListener('touchmove', this.handleGestureMove);
        this.handlerDom.removeEventListener('touchend', this.handleGestureEnd);
        this.handlerDom.removeEventListener('touchcancel', this.handleGestureEnd);

        // Remove Mouse Listener
        this.handlerDom.removeEventListener('mousedown', this.handleGestureStart);

        if(this.loop_sound)
        {
            this.loop_sound.unload();
            this.loop_sound = false;
        }
        if(this.engrenage_sound)
        {
            this.engrenage_sound.unload();
            this.engrenage_sound = false;
        }        

    }
    
    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if( prevProps.menuOpen !== this.props.menuOpen)
        {
            if(this.props.menuOpen)
            {
                if(this.loop_sound) this.loop_sound.pause();
            }else
            {
                if(this.loop_sound) this.loop_sound.play();            
            }
        }
    }
/*
    shouldComponentUpdate(nextProps, nextState)
    {
        // ne doit pas refaire de render, sinon le canvas sera detruit 
        return false;
    }
*/

/* ----------------------------------------------- */

    // Handle the start of gestures
    handleGestureStartFn(evt) {
        evt.preventDefault();

        //console.log("##handleGestureStartFn");

        if(evt.touches && evt.touches.length > 1)   return;
    
        // Add the move and end listeners
        if(this.handlerDom){
            // Add Mouse Listeners
            this.handlerDom.addEventListener('mousemove',this.handleGestureMove, true);
            this.handlerDom.addEventListener('mouseup', this.handleGestureEnd, true);
        }

        if(this.engrenage_sound)    this.engrenage_sound.play();
    
        this.touchStart = true;
        
    };

    // Handle end gestures
    handleGestureEndFn(evt) {
        evt.preventDefault();

        //console.log("##handleGestureEndFn");

        if(evt.touches && evt.touches.length > 0)   return;
    
        // Remove Event Listeners
        if(this.handlerDom){
            // Remove Mouse Listeners
            this.handlerDom.removeEventListener('mousemove', this.handleGestureMove, true);
            this.handlerDom.removeEventListener('mouseup', this.handleGestureEnd, true);
        }

        if(this.engrenage_sound)    this.engrenage_sound.pause();
    
        this.touchStart = false;
    }

    handleGestureMoveFn(evt) {
        evt.preventDefault();

       // this.props.logFn('SwipeHandler:handleGestureMoveFn');
      
        if(!this.touchStart)  return;
      
        const tp = getGesturePointFromEvent(evt);

        const p1 = this.handlerPendule1.getBoundingClientRect();
       // console.log( tp, p1);
        if(isInside( tp, p1 ) && !this.isAiguille1Finished )
        {            
          //  console.log("#### IN P1 angle : ");
            this.positionAiguille( { x: tp.x - p1.left, y: tp.y - p1.top } , 1);  /* on replace dans la zone de touch */
        }

        const p2 = this.handlerPendule2.getBoundingClientRect();
        if(isInside( tp, p2 )  && !this.isAiguille2Finished )
        {
          // console.log("#### IN P2");
            this.positionAiguille( { x: tp.x - p2.left, y: tp.y - p2.top } , 2);  /* on replace dans la zone de touch */
        }
      
    }

    positionAiguille = (p, num_aiguille) =>
    {

        const a = this.get_angle(p);

        if(this._last_angle != false)
        {
            let da = a - this._last_angle;

            if( da > _ANGLE_LIMIT_DEP ) 
            {
                this._last_angle = a;
                return;  // pour éviter les erreurs (touch horizontal qui déclanche des gros angles)
            }
            if( da > 0)  /* que des angles positif : sans des aiguilles d'une montre */
            { 
                // pour minimer l'angle plus on s'approche du centre : est-ce utile ?
                var px = p.x - 180/2;
                var py = p.y - 180/2;
                var dt = Math.sqrt( px*px + py*py ) / Math.sqrt(180 * 180 + 180 * 180);  // width/height: 180/180
                da *= dt * _SPEED_ROTATE;  

                if(num_aiguille == 1) 
                {
                    if(this.state.minute1 + da > 60)                
                        this.setState({ heure1 : (this.state.heure1 + 1)%12, minute1 : this.state.minute1 + da - 60 });
                    else
                        this.setState({ minute1 : this.state.minute1 + da });

                    if(this.state.heure1 >= 12)

                    /* if horaire trouvé */
                    console.log(this.state.heure1, this.state.minute1, Math.abs(this.state.minute1 - _MINUTE0));
                    if( (this.state.heure1 == _HEURE0) && ( Math.abs(this.state.minute1 - _MINUTE0) < _SEUIL_DETECTION_MINUTE) )
                    {
                        this.isAiguille1Finished = true;                        
                        this.setState({ heure1 : _HEURE0, minute1 : _MINUTE0, animation1: true });

                        this.props.logFn("InteractionPendules:positionAiguille() : MEME HORAIRE 1");
                        this.moveGuichet(num_aiguille);

                        if(this.isAiguille1Finished && this.isAiguille2Finished)    
                            window.setTimeout( () => {
                                this.props.onEnd();
                            }, 2 * 1000 );  // 2s
                        if(this.props.onHideHelper1) this.props.onHideHelper1();
                    }                            

                }else
                {
                    if(this.state.minute2 + da > 60)                
                        this.setState({ heure2 : (this.state.heure2 + 1)%12, minute2 : this.state.minute2 + da - 60 });
                    else
                        this.setState({ minute2 : this.state.minute2 + da });

                    /* if horaire trouvé */
                    if( (this.state.heure2 == _HEURE0) && ( Math.abs(this.state.minute2 - _MINUTE0) < _SEUIL_DETECTION_MINUTE) )
                    {
                        this.isAiguille2Finished = true;
                        this.setState({ heure2 : _HEURE0, minute2 : _MINUTE0, animation2: true });

                        this.props.logFn("InteractionPendules:positionAiguille() : MEME HORAIRE 2");
                        this.moveGuichet(num_aiguille);

                        if(this.isAiguille1Finished && this.isAiguille2Finished)
                            window.setTimeout( () => {
                                this.props.onEnd();
                            }, 2 * 1000 );  // 2s
                        if(this.props.onHideHelper2) this.props.onHideHelper2();

                    }

                }


            }
        }
        this._last_angle = a;
    }

    moveGuichet = (num) =>
    {
        this.props.logFn("InteractionPendules:moveGuichet()", num);        
    }

    get_angle = (p) =>
    {
        /* FIXME() 180 x 180 px = taille fixed */
        var x = p.x - 180/2; 
        var y = p.y - 180/2; 
        var angle = Math.atan2(y,x) * 180.0 / Math.PI;
        if(y<0) angle += 360
        return angle;
    }

    /* return { dh, dm} = deg pour aiguille heure, et deg pour aiguille min */
    convert_time_to_deg = (h, m) =>
    {
        const dh = h * 360 / 12 + m * 360 / (12*60);
        const dm = m * 360 / 60;
        return {dh : dh, dm: dm};
    }

    render() {

        //const {onEnd, logFn} = this.props;

        const { heure1, minute1, heure2, minute2, animation1, animation2 } = this.state;

        const d1 = this.convert_time_to_deg(heure1, minute1);
        const style_p1_a1 = { transform: 'rotate('+d1.dh+'deg)', backgroundImage : 'url(./interactifs/CH15/Aiguille01.png' };
        const style_p1_a2 = { transform: 'rotate('+d1.dm+'deg)', backgroundImage : 'url(./interactifs/CH15/Aiguille02.png' };
        const d2 = this.convert_time_to_deg(heure2, minute2);
        const style_p2_a1 = { transform: 'rotate('+d2.dh+'deg)', backgroundImage : 'url(./interactifs/CH15/Aiguille01.png' };
        const style_p2_a2 = { transform: 'rotate('+d2.dm+'deg)', backgroundImage : 'url(./interactifs/CH15/Aiguille02.png' };

        const d0 = this.convert_time_to_deg(_HEURE0, _MINUTE0);
        const style_p0_a1 = { transform: 'rotate('+d0.dh+'deg)', backgroundImage : 'url(./interactifs/CH15/Aiguille01.png'  };
        const style_p0_a2 = { transform: 'rotate('+d0.dm+'deg)', backgroundImage : 'url(./interactifs/CH15/Aiguille02.png' };        

        /* animate guichets */

        let cl_guichet1 = "ensemble_guichet1 "
        if( animation1 )    cl_guichet1+= "guichet1_anim_move";
        else                cl_guichet1+= "guichet1_anim_boucle";
        let cl_guichet2 = "ensemble_guichet2 "
        if( animation2 )    cl_guichet2+= "guichet2_anim_move";
        else                cl_guichet2+= "guichet2_anim_boucle";
        //

        let cl = 'pendule';
        if(window._DEBUG_TOUCH) cl += ' debugTouch ';        


        return  <div className="InteractionPendules" ref={ this.setHandlerDom }>
                    <div className="backgroundPendules" style={{ backgroundImage : 'url(./interactifs/CH15/15_BG.jpg' }}></div>
                    <div className="ensemble_guichet0">
                        <div className="facteur" style={{ backgroundImage : 'url(./interactifs/CH15/15_Facteur.png' }} ></div>
                        <div className="guichet" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet.png' }}>
                            <div className="pendule">
                                <div className="aiguille01" style={ style_p0_a1 }></div>
                                <div className="aiguille02" style={ style_p0_a2 }></div>
                            </div>
                        </div>
                    </div>
                    <div className={ cl_guichet1 }>
                        <div className="facteur" style={{ backgroundImage : 'url(./interactifs/CH15/15_Facteur.png' }}></div>
                        <div className="guichet guichet_bk" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet.png' }}></div>
                        <div className="guichet guichet_red" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet_red.png' }}></div>
                        <div className="guichet guichet_blue" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet_blue.png' }}>
                            <div className={cl} ref={ this.setHandlerPendule1 }>
                                <div className="aiguille01" ref='p1_a1' style={ style_p1_a1 }></div>
                                <div className="aiguille02" ref='p1_a2' style={ style_p1_a2 }></div>
                            </div>
                        </div>
                    </div>
                    <div className={ cl_guichet2 }>
                        <div className="facteur" style={{ backgroundImage : 'url(./interactifs/CH15/15_Facteur.png' }}></div>
                        <div className="guichet guichet_bk" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet.png' }}></div>
                        <div className="guichet guichet_blue" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet_blue.png' }}></div>
                        <div className="guichet guichet_red" style={{ backgroundImage : 'url(./interactifs/CH15/15_Guichet_red.png' }}>
                            <div className={cl} ref={ this.setHandlerPendule2 }>
                                <div className="aiguille01" ref='p2_a1' style={ style_p2_a1 }></div>
                                <div className="aiguille02" ref='p2_a2' style={ style_p2_a2 }></div>
                            </div>
                        </div>
                    </div>
                    { this.props.children }
                </div>

  }
  
}



//----------------------------------------------------------------------------

export default InteractionPendules;



// WEBPACK FOOTER //
// ./src/InteractionPendules.js